import { FormControl, FormHelperText } from "@mui/material";
import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const RichTextEditor = ({ value, onChange, placeholder,error,helperText }) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image", "code-block"],
      ["clean"],
    ],
  };
  const errorStyle = {  }

  return (
      <FormControl fullWidth error={error}>
        <ReactQuill
          theme="snow"
          value={value}
          onChange={onChange}
          modules={modules}
          placeholder={placeholder || "Write something..."}
          style={{ background: "#fff",border: error ? '1px solid #d32f2f' : '' ,borderRadius: "16px",  }}
        />
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>

  );
};

export default RichTextEditor;
